import { useMemo, useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import QuickImportScanMethodsSection from '../../../shared/settings/QuickImportScanMethodsSection';
import Section from '../../../shared/settings/SettingsPageSection';
import useOrganizationSettings from '../../shared/useOrganizationSettings';
import type { QuickImportProjectScanMethodsSettings } from '../../../../../shared/settings/project/scanMethods';
import type { OrganizationSettingsEndpoint } from '../../shared/useOrganizationSettings';

import PropagateQuickImportScanMethodsModal from './PropagateQuickImportScanMethodsModal';

const OrgQuickImportScanMethodsSection: VoidFunctionComponent = () => {
  const [isPropagateModalOpen, setIsPropagateModalOpen] = useState<boolean>(false);
  const endpoint = useMemo<OrganizationSettingsEndpoint>(
    () => `/api/organizations/${window.user?.organizationId ?? 0}/settings/projects/quick-import-scan-methods`,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [window.user?.organizationId],
  );
  const { isDirty, onUpdateSettings, settings, isLoading, onSaveSettings, isSaveButtonDisabled } =
    useOrganizationSettings<QuickImportProjectScanMethodsSettings>({
      endpoint,
      settingsSection: 'project quick import scan methods',
    });

  return (
    <>
      <QuickImportScanMethodsSection
        scopeType="organization"
        isVendoredDetectionEnabled={settings?.projectDefaultQuickImportVendoredDetectionEnabled ?? false}
        onToggleVendoredDetection={(isChecked) =>
          onUpdateSettings({ projectDefaultQuickImportVendoredDetectionEnabled: isChecked })}
        isSnippetDetectionEnabled={settings?.projectDefaultQuickImportSnippetDetectionEnabled ?? false}
        onToggleSnippetDetection={(isChecked) =>
          onUpdateSettings({ projectDefaultQuickImportSnippetDetectionEnabled: isChecked })}
        isDisabled={isLoading.any}
        buttons={
          <Section.Buttons>
            <Section.PropagateButton isDisabled={isDirty} onClick={() => setIsPropagateModalOpen(true)} />
            <Section.SaveButton onClick={onSaveSettings} isLoading={isLoading.save} isDisabled={isSaveButtonDisabled} />
          </Section.Buttons>
        }
      />
      {settings && (
        <PropagateQuickImportScanMethodsModal
          isOpen={isPropagateModalOpen}
          settings={settings}
          onHide={() => setIsPropagateModalOpen(false)}
          endpoint={endpoint}
        />
      )}
    </>
  );
};

export default OrgQuickImportScanMethodsSection;
